import { makeAutoObservable } from "mobx";

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";
import { PageResponse } from "app/common/Model/Shared";
import { searchRevenuePayment } from "app/services/ReportService";
import { exportExcelCheckSuggestFee, exportExcelCheckSuggestfee, exportReportTreamentItem, sriTreatmentReport } from "app/services/ServiceRequestItemService";
import {
  getInitSvitemParticipant,
  updateParticipantsAndReportOfSvItem,
} from "app/services/EncounterParticipantService";
import { recalculateTourCost } from "app/services/ServiceRequestItem";

const DEFAULT_VALUES = {
  fromDate: new Date(),
  toDate: new Date(),
};
export default class CheckSuggestFeesStore {
  searchCheckSuggestFees = {
    ...new SearchObject(),
    ...DEFAULT_VALUES,
  };
  pageCheckSuggestFees = new PageResponse();
  openUpdateListCheckSuggest = false;
  openUpdateReconcile = false;
  listSelectedCheckSuggest = [];
  initialCheckSuggest = null;
  selectedReconcile = {};
  resetSelectedRows = false;

  sumDataReport = null;

  constructor() {
    makeAutoObservable(this);
  }

  pagingCheckSuggestFees = async () => {
    try {
      let { listDepId, encounterParticipants, source, position, ...otherData } = this.searchCheckSuggestFees;
      if (listDepId) {
        if (Array.isArray(listDepId)) {
          otherData.listDepId = listDepId.map((x) => x.id);
        }
      }

      if (encounterParticipants && Array.isArray(encounterParticipants)) {
        const staffIds = encounterParticipants.map((p) => p?.id);
        otherData.staffIds = staffIds;
      }

      if (source && Array.isArray(source)) {
        otherData.sourceIds = source.map((s) => s.id);
      } else if (source) {
        otherData.sourceIds = [source?.id];
      }
      if (position && Array.isArray(position)) {
        otherData.positionIds = position.map((s) => s.id);
      } else if (position) {
        otherData.positionIds = [position?.id];
      }

      const { data } = await sriTreatmentReport({ ...otherData });
      this.pageCheckSuggestFees = data;
      this.getTotalWageParticipants();
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  getTotalWageParticipants = async () => {
    try {
      let { listDepId, encounterParticipants, source, position, ...otherData } = this.searchCheckSuggestFees;
      otherData.getTotalWage = true;
      otherData.getPaging = false;
      if (listDepId) {
        if (Array.isArray(listDepId)) {
          otherData.listDepId = listDepId.map((x) => x.id);
        }
      }

      if (encounterParticipants && Array.isArray(encounterParticipants)) {
        const staffIds = encounterParticipants.map((p) => p?.id);
        otherData.staffIds = staffIds;
      }

      if (source && Array.isArray(source)) {
        otherData.sourceIds = source.map((s) => s.id);
      } else if (source) {
        otherData.sourceIds = [source?.id];
      }

      if (position && Array.isArray(position)) {
        otherData.positionIds = position.map((s) => s.id);
      } else if (position) {
        otherData.positionIds = [position?.id];
      }
      const { data } = await sriTreatmentReport({ ...otherData });
      this.sumDataReport = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu tổng có lỗi");
    }
  };

  handleOpenUpdateCheckSuggest = async (row) => {
    try {
      const { data } = await getInitSvitemParticipant([row]);
      this.initialCheckSuggest = data;

      this.openUpdateListCheckSuggest = true;
    } catch (error) {
      toast.error("Lấy thông tin có lỗi");
    }
  };

  handleOpenUpdateListCheckSuggest = async () => {
    try {
      const { data } = await getInitSvitemParticipant(
        this.listSelectedCheckSuggest
      );
      this.initialCheckSuggest = data;
      this.openUpdateListCheckSuggest = true;
    } catch (error) {
      toast.error("Lấy thông tin có lỗi");
    }
  };

  handleRecalculateTour = async () => {
    if (!this.listSelectedCheckSuggest?.length) {
      toast.warning("Vui lòng chọn ít nhất một bản ghi");
      return;
    }
    try {
      const ids = this.listSelectedCheckSuggest.map(item => item.id);
      const { data } = await recalculateTourCost(ids);
      const results = Array.isArray(data) ? data : [];

      const failItem = results.find((r) => r?.responseStatus === false);
      if (failItem) {
        toast.warning(failItem.responseDetail || "Tính lại tiền tour thất bại.");
      } else {
        toast.success("Tính lại tiền tour thành công");
      }

      this.pagingCheckSuggestFees();
    } catch (error) {
      console.error(error);
      toast.error("Tính lại tiền tour thất bại");
    }
  };

  handleUpdateListCheckSuggest = async (values) => {
    try {
      const { data } = await updateParticipantsAndReportOfSvItem(values?.items);
      const results = Array.isArray(data) ? data : [];

      const failItem = results.find((r) => r?.responseStatus === false);
      if (failItem) {
        toast.warning(failItem.responseDetail || "Cập nhật thất bại.");
      } else {
        toast.success("Cập nhật thông tin thành công!");
      }

      this.listSelectedCheckSuggest = [];
      this.handleCloseUpdateListCheckSuggest();
      this.resetSelectedRows = !this.resetSelectedRows;
      await this.pagingCheckSuggestFees();
    } catch (error) {
      toast.error("Cập nhật thông tin có lỗi");
    }
  };


  setListSelectedCheckSuggest = (list) => {
    this.listSelectedCheckSuggest = list;
  };

  setResetSelectedRows = (boolean) => {
    this.resetSelectedRows = boolean;
  };

  handleCloseUpdateListCheckSuggest = () => {
    this.openUpdateListCheckSuggest = false;
  };

  handleCloseUpdateReconcile = () => {
    this.openUpdateReconcile = false;
  };

  handleChangeFormSearch = (searchCheckSuggestFees) => {
    this.searchCheckSuggestFees = checkSearchObject(
      this.searchCheckSuggestFees,
      searchCheckSuggestFees
    );
    this.pagingCheckSuggestFees();
  };

  normalizeSearchCheckSuggest = (search) => {
    let {
      listDepId,
      encounterParticipants,
      source,
      position,
      ...otherData
    } = search;

    if (listDepId && Array.isArray(listDepId)) {
      otherData.listDepId = listDepId.map((x) => x.id);
    }

    if (encounterParticipants && Array.isArray(encounterParticipants)) {
      otherData.staffIds = encounterParticipants.map((p) => p?.id);
    }

    if (source && Array.isArray(source)) {
      otherData.sourceIds = source.map((s) => s.id);
    } else if (source) {
      otherData.sourceIds = [source?.id];
    }

    if (position && Array.isArray(position)) {
      otherData.positionIds = position.map((p) => p.id);
    } else if (position) {
      otherData.positionIds = [position?.id];
    }

    return otherData;
  };


  handleExport = async (searchObj) => {
    const search = this.normalizeSearchCheckSuggest(searchObj);
    try {
      const response = await exportExcelCheckSuggestFee(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "DANH_SACH_DOI_SOAT_TIEN_TOUR.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  resetStore = () => {
    this.searchCheckSuggestFees = {
      ...new SearchObject(),
      ...DEFAULT_VALUES,
    };
    this.pageCheckSuggestFees = new PageResponse();
    this.sumDataReport = null;
  };
}
